import { Box, TextField, Button } from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";
import Api from "../../../API/API";
import cookie from "../../../API/cookie";

// 전체 페이지 로그인처럼 수정필요(현재 코드는 중복로그인 설정이 안됨)
function LoginPage() {

  const publicUrl = process.env.PUBLIC_URL;
  const [ID, setID] = React.useState("");
  const [PW, setPW] = React.useState("");
  const handleChangeID = (event) => {
    setID(event.target.value);
  };
  const handleChangePW = (event) => {
    setPW(event.target.value);
  };

  const [inputValue, setInputValue] = React.useState('');

  const handleInputChange = (event) => {
    setInputValue(event.target.value);
  }

  const handleEnterKeyPress = (event) => {
    if (event.key === "Enter"){
      console.log("Enter key Pressed");
      handlesubmit();
    }
  }

  function deleteAllCookies() {
    const cookies = document.cookie.split(';')
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i]
      const eqPos = cookie.indexOf('=')
      const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie
      document.cookie = name + '=;max-age=0'
    }
  }

  const handlesubmit = async () => {
    const getData = async () => {
      const infoBody = await Api.getAPI_AccountLogin_Syns(ID, PW);
      if (infoBody != null) {
        const infoBody2 = await Api.getUserData(infoBody.data.access_token);
        if (infoBody2.status == 200) {
          if (cookie.getCookie('accessToken') != "") {
            if (cookie.getCookie('accessToken') != infoBody.data.access_token) {
              deleteAllCookies();
              cookie.setCookie("is_Login", 0, 1);
            } else {
              cookie.setCookie("is_Login", 1, 1);
              cookie.setCookie("userAccount", ID, 1);
              cookie.setCookie("userID", infoBody2.data.id, 1);
              cookie.setCookie("accessToken", infoBody.data.access_token, 1);
              cookie.setCookie('is_staff', infoBody2.data.is_staff, 1);
            }
          }
          else {
            cookie.setCookie("is_Login", 1, 1);
            cookie.setCookie("userAccount", ID, 1);
            cookie.setCookie("userID", infoBody2.data.id, 1);
            cookie.setCookie("accessToken", infoBody.data.access_token, 1);
            cookie.setCookie('is_staff', infoBody2.data.is_staff, 1);
          }
          window.location.href ="/";
        }
        else {
          alert('서버 오류입니다. neurotx@neurotx.org로 연락 주세요');
        }
      }
      else { alert('ID와 비밀번호를 확인해주세요.') }
    };
    getData();
  };

  return (
    <Box
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "#F0F0F0",
        padding: "0 16px",
        boxSizing: "border-box",
      }}
    >
      <Box
        style={{
          width: "100%",
          maxWidth: 381,
          textAlign: "center",
          position: "relative",
        }}
      >
        <Box
          style={{
            width: "100%",
            margin: 0,
            padding: 0,
          }}
        >
          <img
            style={{ marginBottom: 30, maxWidth: "100%", height: "auto" }}
            alt="home icon"
            src={`${publicUrl}/logoLogin.png`}
          />
          <TextField
            fullWidth
            value={ID}
            onChange={handleChangeID}
            style={{ marginBottom: 10 }}
            inputProps={{ style: { fontFamily: "GmarketSansMedium" } }}
            placeholder="user ID"
            onKeyPress={handleEnterKeyPress}
          />
          <TextField
            fullWidth
            value={PW}
            type="password"
            onChange={handleChangePW}
            placeholder="Password"
            inputProps={{ style: { fontFamily: "GmarketSansMedium" } }}
            onKeyPress={handleEnterKeyPress}
            style={{ marginTop: 8 }}
          />
          <Button
            variant="contained"
            style={{
              width: "100%",
              backgroundColor: "#3c486c",
              marginTop: 20,
              fontFamily: "GmarketSansMedium",
            }}
            onClick={handlesubmit}
          >
            Log in
          </Button>

          {/* 하단 링크 버튼들: 모바일에서 깨지지 않도록 flex 사용 */}
          <Box
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginTop: 10,
            }}
          >
            <Link to="/FindID" style={{ textDecoration: "none" }}>
              <Button
                variant="text"
                style={{ fontFamily: "GmarketSansMedium", paddingLeft: 0 }}
              >
                Find ID
              </Button>
            </Link>
            <Link to="/SignUp" style={{ textDecoration: "none" }}>
              <Button
                variant="text"
                style={{ fontFamily: "GmarketSansMedium", paddingRight: 0 }}
              >
                Sign Up
              </Button>
            </Link>
          </Box>
        </Box>

        <Box
          style={{
            width: "100%",
            textAlign: "center",
            marginTop: 40,
          }}
        >
          <h6 style={{ marginBottom: 0, color: "#A0A0A0" }}>Version. 1.3.5 Last Update: 2026.04.17</h6>
          <h5 style={{ marginTop: 0, color: "#A0A0A0" }}>
            Copyright 2020 ⓒ NeuroTx All RIGHT RESERVED
          </h5>
         <h6 style={{ marginTop: 0, marginBottom:0, color: "#A0A0A0" }}>
            오류 문의: shikgom2@korea.ac.kr / 010-9425-3617
          </h6>
        </Box>
      </Box>
    </Box>
  );
}

export default LoginPage;
